import React from 'react';
import DateField from '../../../components/forms/DateField';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';
import { isEqual } from 'lodash';

interface GeneralExpenseFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
}

const GeneralExpenseFilters: React.FC<GeneralExpenseFiltersProps> = ({ filters, updateFilters }) => {

    // HOOKS

    // RENDER 

    return (
        <>
            <CustomTextDelayInput
                id="concept"
                label="Concepto"
                placeholder="Buscar por concepto"
                filters={filters}
                updateFilters={updateFilters}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fechas de recogida"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.date?.startDate ? new Date(filters.filter_filters.date.startDate) : null}
                endDate={filters.filter_filters?.date?.endDate ? new Date(filters.filter_filters.date.endDate) : null}
                onChange={(date: any) => {
                    const filters_date = filters.filter_filters?.date;
                    const date_range = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (date_range && !isEqual(filters_date, date_range)) {
                        updateFilters({ date: date_range });
                    } else if (!date_range && filters_date) {
                        updateFilters({ date: null });
                    }
                }}
            />
        </>
    );
};

export default GeneralExpenseFilters;
